import styled, { css } from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const RowWithRule = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.color.darkerGrayRGBA(0.2)};
`;

export const Container = styled.div`
  margin: 0;
  padding: 0;
  > div {
    &:first-child {
      h2 {
        margin-top: 0px;
      }
    }
  }
`;

export const GroupLabel = styled('h2')`
  ${({ theme }) => css`
    ${theme.typography.baseStrong}
    color: ${theme.color.spaceGray};
    margin-top: ${theme.x3spacePx}px;
    margin-bottom: ${theme.x1spacePx}px;
  `}
`;
